import { Component, inject, resource } from '@angular/core';
import { OrganizationsStore } from '../../../organizations/store/organizations.store';
import { Button, NotificationService, SimpleDialog } from 'excellence-ui';
import { Api } from '../../../../core/clients/omni-core/api';
import {
  listOrganizationMembers,
  listOrgInvites,
} from '../../../../core/clients/omni-core/functions';
import { SettingsOrgaInviteCreateDialog } from '../../dialogs/settings-orga-invite-create-dialog/settings-orga-invite-create-dialog';
import { TranslocoPipe, TranslocoService } from '@jsverse/transloco';
import { SettingsOrganizationInviteStatusPipe } from '../../pipes/settings-organization-invite-status-pipe';
import { OrganizationRolePipe } from '../../../organizations/pipes/organization-role-pipe';

@Component({
  templateUrl: './settings-members-page.html',
  imports: [
    Button,
    SimpleDialog,
    SettingsOrgaInviteCreateDialog,
    TranslocoPipe,
    SettingsOrganizationInviteStatusPipe,
    OrganizationRolePipe,
  ],
})
export class SettingsMembersPage {
  private api = inject(Api);
  private notificationService = inject(NotificationService);
  private organizationsStore = inject(OrganizationsStore);
  private translocoService = inject(TranslocoService);
  protected state = this.organizationsStore.selected;

  protected invites = resource({
    params: () => ({
      orgaId: this.organizationsStore.selectedId(),
    }),
    loader: async ({ params }) => {
      const orgaId = params.orgaId;
      if (!orgaId) {
        throw new Error('Organization ID is required to load invites');
      }
      const res = await this.api.invoke(listOrgInvites, {
        id: orgaId,
        limit: 999,
      });
      return res.items.filter((invite) => invite.status !== 'ACCEPTED');
    },
  });

  protected members = resource({
    params: () => ({
      orgaId: this.organizationsStore.selectedId(),
    }),
    loader: async ({ params }) => {
      const orgaId = params.orgaId;
      if (!orgaId) {
        throw new Error('Organization ID is required to load members');
      }
      const res = await this.api.invoke(listOrganizationMembers, {
        id: orgaId,
        limit: 999,
      });
      return res.items;
    },
  });

  protected onCreateMemberSubmit(dialog: SimpleDialog) {
    dialog.close();
    this.notificationService.showSuccess({
      title: this.translocoService.translate(
        'cockpit.settings.members.page.notifications.inviteSuccess',
      ),
    });
    this.invites.reload();
  }
}
